import type { ReactElement, ReactNode } from "react";

import type { IconSize } from "@similarweb/icons";
import { Dropdown, IconButton, Tooltip } from "@similarweb/ui-components";

import { StyledDropdownParent } from "../../dropdown/styles";
import type { MenuItem, MenuItemOption } from "../types";

import { DROPDOWN_WIDTH } from "./const";

export type OptionsMenuDropdownBaseProps = {
    className?: string;
    dataAutomation?: string;
    id: string;
    isDisabled?: boolean;
    dropdownWidth?: number;
    placement?: string;
    buttonIconSize?: IconSize;
    tooltipContent?: ReactNode;
    onToggle?: (isOpen: boolean, isOutsideClick?: boolean) => void;
    onSelect?: (option: MenuItemOption) => void;
    isAppendToBody?: boolean;
};

type OptionsMenuDropdownProps = OptionsMenuDropdownBaseProps & {
    children: ReactElement[] | ReactElement;
};

const OptionsMenuDropdown = ({
    className,
    dataAutomation = "options-button",
    id,
    isDisabled,
    placement = "bottom-right",
    dropdownWidth = DROPDOWN_WIDTH,
    buttonIconSize = "sm",
    tooltipContent,
    onSelect,
    onToggle,
    children,
    isAppendToBody = true,
}: OptionsMenuDropdownProps) => {
    const button = (
        <Tooltip
            enabled={typeof tooltipContent !== "undefined"}
            key="button-item"
            content={tooltipContent}
        >
            <div>
                <IconButton
                    type="flat"
                    iconSize={buttonIconSize}
                    iconName="dots-more"
                    dataAutomation={dataAutomation}
                    isDisabled={isDisabled}
                />
            </div>
        </Tooltip>
    );

    const handleDropdownClick = (item: Readonly<MenuItem>): void => {
        onSelect?.(item.id);
    };

    return (
        <StyledDropdownParent
            className={className}
            id={id}
            onClick={(e) => e.stopPropagation()}
        >
            <Dropdown
                appendTo={isAppendToBody ? "body" : `#${id}`}
                dropdownPopupPlacement={placement}
                width={dropdownWidth}
                onToggle={onToggle}
                onClick={handleDropdownClick}
            >
                {[button, ...(Array.isArray(children) ? children : [children])]}
            </Dropdown>
        </StyledDropdownParent>
    );
};

export default OptionsMenuDropdown;
